
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal-mentions",
      function () {
        return require("private-next-pages/legal-mentions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal-mentions"])
      });
    }
  